import React from 'react';

function Footer() {
  return (
    <div className='footer'>Designed and Coded By Selami Demir | 
    <a href="https://github.com/selamidemir" title="github selami demir">Gihub</a> | 
    <a href="https://netbilio.com" title='Netbilio Teknoloji'>Netbilio</a>
    </div>
  )
}

export default Footer;